import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NextcloudFile, AbstractFile, MailAttachement, LocalFile } from 'src/app/classes';
import { SingleInputComponent, SingleInputData } from '../../../../../components/dialog-components/single-input/single-input.component';
import { MatDialog } from '@angular/material/dialog';
import { FileService } from '../../../services/file.service';
import { MailService } from 'src/app/lib/mail/services/mail.service';
import { SelectFileDialogComponent, SelectFileDialogComponentInputData } from '../../dialog/select-file-dialog/select-file-dialog.component';

@Component({
  selector: 'app-file-list-entry',
  templateUrl: './file-list-entry.component.html',
  styleUrls: ['./file-list-entry.component.css']
})
export class FileListEntryComponent implements OnInit {

  _file: AbstractFile = null;
  type: number = AbstractFileTypes.Unknown;
  fileType: string = null;
  fileName: string = null;
  fileSize: string = null;

  @Input() clickable: boolean = true;
  @Input() showDownloadIcon: boolean = false;
  @Input() showPreviewIcon: boolean = false;
  @Input() showUploadNow: boolean = false;
  @Input() showRemover: boolean = false;
  @Input() showOptionsMenu: boolean = false;

  @Output() emitRefresh: EventEmitter<void> = new EventEmitter();
  @Output() clickEmitter: EventEmitter<AbstractFile> = new EventEmitter();
  @Output() uploadEmitter: EventEmitter<AbstractFile> = new EventEmitter();
  @Output() onDeleteFromNextcloud: EventEmitter<any> = new EventEmitter();
  @Output() removeEmitter: EventEmitter<void> = new EventEmitter();

  @Input() set file(file: AbstractFile) {
    this._file = file;
    if ((file as NextcloudFile).href) {
      this.type = AbstractFileTypes.NextcloudFile;
      this.fileName = this.getFileName(file as NextcloudFile);
      this.fileSize = this.getPrettyFileSize(file as NextcloudFile);
    }
    else if ((file as MailAttachement).name){
      this.type = AbstractFileTypes.MailAttachement;
      this.fileName = (file as any).name;
      this.fileSize = null;
    } else if((file as LocalFile).localName){
      this.type = AbstractFileTypes.LocalFile;
      this.fileName = (file as LocalFile).localName,
      this.fileSize = FileService.prettyFileSize((file as LocalFile).size.toFixed(0))
    }
    this.fileType = FileService.getFileType(file? file.type: null, this.fileName?.split('.')[1]);
  }

  get file(): AbstractFile {
    return this._file;
  }

  constructor(
    private _fileService: FileService,
    private _mailService: MailService,
    private _dialog: MatDialog
  ) {

  }

  downloadAndPreview(event: MouseEvent){
    event.stopPropagation();
    let callback = (result: Blob) => {
      const blob = new Blob([result], { type: this.file.type });
      const url= window.URL.createObjectURL(blob);
      window.open(url);
    };
    if(this.type == AbstractFileTypes.MailAttachement) {
      let observable = this._mailService.downloadMailAttachement((this._file as MailAttachement).mail.messageId, (this._file as MailAttachement).mail.inbox, (this._file as MailAttachement).name);
      if(observable) observable.subscribe(callback);
    } else if(this.type == AbstractFileTypes.NextcloudFile){
      let observable = this._fileService.getFileByPath((this._file as NextcloudFile).href);
      if(observable) observable.subscribe(callback);
    } else if(this.type == AbstractFileTypes.LocalFile){
      callback((this.file as LocalFile).blob);
    } else throw("don't know how to download this file ...");
  }

  getFileName(file: NextcloudFile): string {
    if (file.type == "folder") {
      let array = file.href.split("/");
      if (array.length > 1) {
        return array[array.length - 2];
      }
    } else {
      let array = file.href.split("/");
      if (array.length > 0) {
        return array[array.length - 1];
      }
    }

    return "Unbekannt";
  }

  getPrettyFileSize(file: NextcloudFile): string {
    if (file && file.size) {
      return FileService.prettyFileSize(file.size);
    }
    return "Unbekannte Dateigröße";
  }

  move(){
    if((this.file as NextcloudFile).href){
      let file: NextcloudFile = (this.file as NextcloudFile);
      this._dialog.open(SelectFileDialogComponent, {
        panelClass: "no-padding-dialog-container",
        autoFocus: false,
        data: {
          visibleTypes: 'folder'
        }
      }).afterClosed().subscribe((result: NextcloudFile) => {
        if (result && result.type === "folder") {
          //this._fileService.renameFile(file.href, result.href + this.fileName).subscribe(() => this.emitRefresh.emit());
        }
      });
    }
  }

  ngOnInit(): void {
  }

  onClick(){
    this.clickEmitter.emit(this._file);
  }

  remove(event?: MouseEvent){
    if(event) event.stopPropagation();
    if(this.type != AbstractFileTypes.NextcloudFile){
      if(this.removeEmitter) this.removeEmitter.emit();
    } else {
      //this._fileService.removeFileFromNextcloud(this._file as NextcloudFile).subscribe(() => this.onDeleteFromNextcloud.emit());
    }
  }

  rename(event?: MouseEvent){
    if(event) event.stopPropagation();
    if((this.file as NextcloudFile).href){
      let file: NextcloudFile = (this.file as NextcloudFile);
      var type = "Datei ", article = "die";
      if(this.file.type == "folder"){
        type = "Ordner ";
        article = "den";
      }
      let ref = this._dialog.open(SingleInputComponent, {
        width: "400px",
        data: {
          "buttonText": type + "umbenennen",
          "headline": type + "umbenennen",
          "subTitle": "Vergeben Sie eine neue Bezeichnung für " + article + " " + type + ":",
          "highlighted": this.fileName,
          "icon": "edit",
          "label": "Bezeichnung",
          "placeholder": "z.B. Vorgang XYZ",
          "presetted": this.fileName
        } as SingleInputData
      })
      ref.afterClosed().subscribe((result: string) => {
        if (result) {
          let array = file.href.split("/");
          array[array.length-2] = result;
          //this._fileService.renameFile(file.href, array.join("/")).subscribe(() => this.emitRefresh.emit());
        }
      });
    }
  }

  uploadNow(event: MouseEvent){
    event.stopPropagation();
    this.uploadEmitter.emit(this._file);
  }

}

const AbstractFileTypes = {
  "Unknown": 0,
  "NextcloudFile": 1,
  "MailAttachement": 2,
  "LocalFile": 3
};